import { ReactTFC } from "../../../../utils/fp/missing-ts-parts";
import { css } from "@emotion/react";
import { SwarovskiButton } from "../../../../components/_shared-components/ui-elements/SwarovskiButton";
import React from "react";

export const SwishQrCode: ReactTFC<{
  code: string;
  url: string;
  translations: { openInApp: React.ReactNode };
}> = props => {
  return (
    <div
      css={css`
        text-align: center;
      `}
    >
      <div
        css={css`
          aspect-ratio: 1 / 1;

          max-width: 500px;

          margin: 0 auto;
        `}
      >
        <img src={`/storefront/shop/swish/${props.code}`} />
      </div>

      <SwarovskiButton variant={"plain-underline"} as={"a"} isInternal={false} link={props.url} target={"_blank"}>
        {props.translations.openInApp}
      </SwarovskiButton>
    </div>
  );
};
